document.addEventListener('DOMContentLoaded', function () {

  var section = document.querySelector('.fc-pshow');
  var rows = document.querySelectorAll('.fc-pshow__row');
  /*
    Detecție iOS proprie, independentă de alte scripturi (nu depinde
    de ordinea de încărcare față de header.js) - verifică direct
    user agent-ul, sigur indiferent de ce alt script a rulat sau nu.
  */
  var ua = navigator.userAgent || '';
  var isIOS = /iPad|iPhone|iPod/i.test(ua);
  /*
    FIX iOS/WebKit: sistemul vechi depindea de evenimentul window 'scroll'
    cu getBoundingClientRect calculat manual - pe WebKit (Safari/Chrome iOS),
    acest lucru nu se re-evalua corect fără o interacțiune suplimentară
    (ex: swipe pe carusel), lăsând produsele invizibile (opacity:0) până
    la acea interacțiune. IntersectionObserver e API-ul standard, robust,
    făcut exact pentru detectarea vizibilității unui element, și funcționează
    identic pe toate browserele.
  */
  function handleBgFade() {
    if (!section) return;
    var rect = section.getBoundingClientRect();
    var windowHeight = window.innerHeight;
    var isVisible = rect.top < windowHeight * 0.9 && rect.bottom > windowHeight * 0.1;

    if (isVisible) {
      section.classList.add('fc-bg-visible');
    } else {
      section.classList.remove('fc-bg-visible');
    }
  }

  if (!isIOS && 'IntersectionObserver' in window) {
    var rowObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var row = entry.target;
        var cards = row.querySelectorAll('.fc-pshow__card');
        var header = row.querySelector('.fc-pshow__row-header');
        var sideCards = row.querySelectorAll('.fc-pshow__side-card');

        if (entry.isIntersecting) {
          row.classList.add('fc-row-visible');
          if (header) header.classList.add('is-visible');
          sideCards.forEach(function (sc) { sc.classList.add('is-visible'); });
          cards.forEach(function (card, i) {
            setTimeout(function () {
              card.classList.add('fc-revealed');
            }, i * 80);
          });
        } else {
          row.classList.remove('fc-row-visible');
          if (header) header.classList.remove('is-visible');
          sideCards.forEach(function (sc) { sc.classList.remove('is-visible'); });
          cards.forEach(function (card) {
            card.classList.remove('fc-revealed');
          });
        }
      });
    }, { threshold: 0.15 });

    rows.forEach(function (row) {
      rowObserver.observe(row);
    });
  } else {
    /*
      FIX iOS: pe iPhone, animația de reveal la scroll tot depindea
      de comportamentul WebKit pentru IntersectionObserver, care nu
      se declanșa fiabil fără o interacțiune (swipe). Cea mai sigură
      soluție e să eliminăm complet dependința de animație pe iOS -
      tricourile apar direct, fără fade-in, fără nicio condiție de scroll.
      Fallback-ul de mai jos (folosit și pentru browsere foarte vechi
      fără IntersectionObserver) face exact asta.
    */
    rows.forEach(function (row) {
      var cards = row.querySelectorAll('.fc-pshow__card');
      var header = row.querySelector('.fc-pshow__row-header');
      var sideCards = row.querySelectorAll('.fc-pshow__side-card');
      row.classList.add('fc-row-visible');
      if (header) header.classList.add('is-visible');
      sideCards.forEach(function (sc) { sc.classList.add('is-visible'); });
      cards.forEach(function (card) { card.classList.add('fc-revealed'); });
    });
  }
  if ('IntersectionObserver' in window) {
    var bgObserver = new IntersectionObserver(function () {
      handleBgFade();
    }, { threshold: [0, 0.1, 0.9, 1] });
    if (section) bgObserver.observe(section);
  }

  window.addEventListener('scroll', handleBgFade);
  handleBgFade();

  // Slider automat stanga-dreapta + scroll cu mouse
  rows.forEach(function (row) {
    var track = row.querySelector('.fc-pshow__track');
    var trackWrap = row.querySelector('.fc-pshow__track-wrap');
    if (!track || !trackWrap) return;

    var cardWidth = 0;
    var autoInterval;

    function getCardWidth() {
      var firstCard = track.querySelector('.fc-pshow__card');
      if (!firstCard) return 0;
      return firstCard.offsetWidth + 20;
    }

    /*
      FIX iOS: poziția inițială bazată pe scrollWidth depindea de cât
      de repede se încărcau imaginile - dacă nu erau gata la timp,
      scrollWidth ieșea greșit și caruselul pornea dintr-o poziție
      incorectă, dând impresia că produsele "vin din stânga" abia
      după câteva secunde. Pornim simplu de la 0 (stânga) - poziție
      fixă, garantat corectă, fără nicio dependință de imagini.
    */
    trackWrap.scrollLeft = 0;

    function startAuto() {
      autoInterval = setInterval(function () {
        cardWidth = getCardWidth();
        var maxScroll = trackWrap.scrollWidth - trackWrap.clientWidth;
        if (trackWrap.scrollLeft >= maxScroll - 1) {
          trackWrap.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          trackWrap.scrollBy({ left: cardWidth, behavior: 'smooth' });
        }
      }, 3000);
    }

    function stopAuto() {
      clearInterval(autoInterval);
    }

    startAuto();

    trackWrap.addEventListener('mouseenter', stopAuto);
    trackWrap.addEventListener('mouseleave', function() {
      stopAuto();
      startAuto();
    });

    trackWrap.addEventListener('wheel', function (e) {
      e.preventDefault();
      stopAuto();
      trackWrap.scrollLeft += e.deltaY * 2;
      clearTimeout(trackWrap._wheelTimer);
      trackWrap._wheelTimer = setTimeout(function() {
        stopAuto();
        startAuto();
      }, 2000);
    }, { passive: false });

    var isDown = false;
    var startX;
    var scrollLeft;

    trackWrap.addEventListener('mousedown', function (e) {
      isDown = true;
      stopAuto();
      startX = e.pageX - trackWrap.offsetLeft;
      scrollLeft = trackWrap.scrollLeft;
      trackWrap.style.cursor = 'grabbing';
    });

    trackWrap.addEventListener('mouseup', function () {
      isDown = false;
      trackWrap.style.cursor = 'grab';
      setTimeout(function() {
        stopAuto();
        startAuto();
      }, 2000);
    });

    trackWrap.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - trackWrap.offsetLeft;
      var walk = (x - startX) * 2;
      trackWrap.scrollLeft = scrollLeft - walk;
    });
  });

  // Efect magnify
  var tracks = document.querySelectorAll('.fc-pshow__track');
  tracks.forEach(function (track) {
    var cards = track.querySelectorAll('.fc-pshow__card');
    cards.forEach(function (card, index) {
      card.addEventListener('mouseenter', function () {
        cards.forEach(function (c, i) {
          var distance = Math.abs(i - index);
          if (distance === 0) {
            c.style.transform = 'scale(1.2)';
            c.style.zIndex = '10';
          } else if (distance === 1) {
            c.style.transform = 'scale(0.888)';
          } else {
            c.style.transform = 'scale(0.8)';
          }
        });
      });

      card.addEventListener('mouseleave', function () {
        cards.forEach(function (c) {
          c.style.transform = 'scale(1)';
          c.style.zIndex = '1';
        });
      });
    });
  });

  // Deco cards
  var decoCards = document.querySelectorAll('.fc-pshow__deco-card');
  decoCards.forEach(function (card) {
    card.classList.add('fc-deco-active');
  });

});